import { useEffect, useState } from "react";
import { Button, Modal, Space } from 'antd';
import { CloseOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";

const ImageModal = ({ isOpen, images, onClose, initialIndex }) => {
    const [currentIndex, setCurrentIndex] = useState(initialIndex);
  
    useEffect(() => {
      setCurrentIndex(initialIndex);
    }, [initialIndex, isOpen]);
  
    const handleNext = () => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };
  
    const handlePrev = () => {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    const handleClickOutsideImage = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    }
  
    if (!isOpen) return null;

    return (
        <div className="fixed top-0 left-0 w-screen h-screen bg-gray-400/40 z-[9999] flex flex-col justify-center items-center" onClick={handleClickOutsideImage}>
            <p className="self-end m-0 cursor-pointer mr-5" onClick={onClose}><CloseOutlined style={{ fontSize: '22px', color: 'black' }} /></p>
            <div className="flex items-center justify-center gap-2 w-[90%] h-[90%]">
                {images.length > 1 && <p className="bg-orange-600 p-1 rounded-full cursor-pointer" onClick={handlePrev}><LeftOutlined style={{ fontSize: '20px', color: '#FFF' }} /></p>}
                <img src={images[currentIndex]} alt="preview" style={{ width: '90%', height: '90%', borderRadius: '6px' }} />
                {images.length > 1 && <p className="bg-orange-600 p-1 rounded-full cursor-pointer" onClick={handleNext}><RightOutlined style={{ fontSize: '20px', color: '#FFF' }} /></p>}
            </div>
        </div>
    )

    return (
        <Modal
            open={isOpen}
            title=""
            onOk={onClose}
            onCancel={onClose}
            footer={(_, { OkBtn, CancelBtn }) => ( <></> )}
        >
            <div className="mt-5 mb-4 flex items-center justify-center gap-2">
                {images.length > 1 && <p className="bg-orange-600 p-1 rounded-full cursor-pointer" onClick={handlePrev}><LeftOutlined style={{ fontSize: '20px', color: '#FFF' }} /></p>}
                <img src={images[currentIndex]} alt="preview" style={{ maxWidth: '90%', borderRadius: '6px' }} />
                {images.length > 1 && <p className="bg-orange-600 p-1 rounded-full cursor-pointer" onClick={handleNext}><RightOutlined style={{ fontSize: '20px', color: '#FFF' }} /></p>}
            </div>
        </Modal>
    )
  
    return (
      <div className="modal-backdrop">
        <div className="modal-content">
          <span className="modal-close" onClick={onClose}>&times;</span>
          <img src={images[currentIndex]} alt="preview" style={{ maxWidth: '100%' }} />
          <div>
            <button onClick={handlePrev}>Prev</button>
            <button onClick={handleNext}>Next</button>
          </div>
        </div>
      </div>
    );
};

export default ImageModal;